import React from 'react';
import Navbar from '../components/landing/Navbar';

export default function Contact() {
  return (
    <div style={{ paddingTop: '100px', textAlign: 'center' }}>
      <Navbar />
      <h1>Contact Sales</h1>
      <p>Coming Soon</p>
    </div>
  );
}